import React from "react"
import { FaMapMarkerAlt, FaEnvelope } from "react-icons/fa"
import styles from "./footer.module.scss"
import GooglePlayImg from "./GooglePlayImg"
import AppStoreImg from "./AppStoreImg"
import { graphql, Link, useStaticQuery } from "gatsby"

export default function Footer() {
  const data = useStaticQuery(graphql`
  query {
    site {
      siteMetadata {
        iosApp
        googlePlayApp
      }
    }
  }
`)

const { iosApp, googlePlayApp } = data.site.siteMetadata

  return (
    <footer className={styles.footer}>
      <div className={styles.footerInner}>
        <div className={styles.footerLeft}>
          <h1 className={styles.logo}>BeepBeep</h1>
          <a href={googlePlayApp}>
            <GooglePlayImg />
          </a>
          <a href={iosApp}>
            <AppStoreImg />
          </a>
        </div>

        <div className={styles.footerRight}>
          <div className={styles.bottomItem}>
            <FaMapMarkerAlt className={styles.bottomItemIcon} />
            <span>London, UK</span>
          </div>

          <div className={styles.bottomItem}>
            <FaEnvelope className={styles.bottomItemIcon} />
            <span><Link to='/contact'>Contact Us</Link></span>
          </div>

          <div className={styles.bottomItem}>
            <span><Link to='/privacy-policy'>Privacy Policy</Link></span>
          </div>

          
          <div className={styles.bottomItem}>
            <span><Link to='/terms'>Terms</Link></span>
          </div>
        </div>
      </div>
    </footer>
  )
}
